import { z } from "zod";
import { MachineStatus as MachineStatusEnum, ServiceMode as ServiceModeEnum } from "@domain/enums/machine.enums";

export const MachineStatus = z.nativeEnum(MachineStatusEnum);

export const ServiceMode = z.nativeEnum(ServiceModeEnum);

export const MachineServiceSchema = z.object({
  id: z.number(),
  name: z.string(),
  service_type: z.string(),
  service_mode: ServiceMode,
  available: z.boolean(),
  description: z.string().nullable().optional(),
  price_label: z.string().nullable().optional(),
  hint: z.string().nullable().optional(),
  icon_url: z.string().nullable().optional(),
  display_order: z.number().optional().default(0),
  enabled: z.boolean().optional().default(true),
});

export const MachinePhotoSchema = z.object({
  id: z.number(),
  url: z.string()
});

export const MachineTariffSchema = z.object({
  id: z.number(),
  description: z.string()
});

export const MachineItemSchema = z.object({
  id: z.number().int(),
  status: MachineStatus,
  title: z.string(),
  description: z.string(),
  address: z.string(),
  working_hours: z.string(),
  free_cells: z.number().int(),
  machine_number: z.string(),
  services: z.array(MachineServiceSchema),
  photos: z.array(MachinePhotoSchema),
  tariffs: z.array(MachineTariffSchema),
  user_can_order: z.boolean().nullable().optional(),
  ban_message: z.string().nullable().optional()
});

export const FilteredMachinesResponseSchema = z.object({
  machine_ids: z.array(z.number())
});

export const MachineListItemSchema = z.object({
  id: z.number(),
  latitude: z.number().nullable(),
  longitude: z.number().nullable(),
  status: MachineStatus,
});

export const FilterMachinesRequestSchema = z.object({
  service_types: z.array(z.string()),
  only_available: z.boolean().optional().default(true)
});


export const MachineItemResponseSchema = MachineItemSchema;

export const MachineListResponseSchema = z.array(MachineListItemSchema);

